import {HA_TYPEAHEAD_LID_SEARCH} from '../experiments';

export function isDestinationChanged(prevSearch, newDestination) {
    if (!prevSearch) {
        return !!newDestination.term;
    }
    if (!newDestination || !newDestination.term) {
        return true;
    }

    return prevSearch.toLowerCase() !== newDestination.term.toLowerCase();
}

export function getDestinationTerm(destination) {
    return (destination && destination.term) || '';
}

export const isListingIdSearchTurnedOn = () =>
    global &&
    global.window &&
    window.__ABACUS__ &&
    window.__ABACUS__[HA_TYPEAHEAD_LID_SEARCH] &&
    window.__ABACUS__[HA_TYPEAHEAD_LID_SEARCH].value > 0;

export function isListingIdSearch(result) {
    return (
        isListingIdSearchTurnedOn() &&
        result &&
        result.listingProps &&
        result.listingProps.listingId
    );
}

export function isMultiUnitListingIdSearch(result) {
    return (
        isListingIdSearchTurnedOn() &&
        result &&
        result.listingProps &&
        result.listingProps.unitId
    );
}
